var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OffRampContainer"},[_vm._v(" This is the chapter off ramp ")])}
var staticRenderFns = []

export { render, staticRenderFns }